import React from 'react';
import Wrapper from '../Wrapper';
import Body from './components/Body';
import Frame from './components/Frame';
import Header from './components/Header';
import { ICard } from './interface';

function Card(props: ICard) {
  const isShowed = !!(props.subtitle !== '' || props.subtitle !== undefined);

  return (
    <Frame.Base
      isActive={props.isActive}
      display={props.display}
      gridArea={props.gridArea}
      className={props.highlighted}
      width={props.width}
      maxWidth={props.maxWidth}
      height={props.height}
      backgroundColor={props.backgroundColor}
      color={props.color}
      justifyContent={props.justifyContent}
      margin={props.margin}
      padding={props.padding}
      flexGrow={props.flexGrow}
      minHeight={props.minHeight}>
      <Header.Base>
        <Header.Button>{props.leftButton}</Header.Button>
        <Wrapper.Default isActive>
          <Header.Title className="Income_atemp">{props.title}</Header.Title>
          <Header.Subtitle isShowed={isShowed}>
            {props.subtitle}
          </Header.Subtitle>
        </Wrapper.Default>
        <Header.Button>{props.rightButton}</Header.Button>
      </Header.Base>
      <Body.Content
        flexDirection={props.flexDirection}
        justifyContent={props.justifyContent}>
        {props.children}
      </Body.Content>
    </Frame.Base>
  );
}

export default Card;
